








import { defineComponent, PropType, useContext } from '@nuxtjs/composition-api'
import { Location } from '@/composables/collection/use-collection-taiwan'

export default defineComponent({
  props: {
    query: {
      type: Object,
      default: {},
    },
    location: {
      type: Object as PropType<Location>,
      required: true,
    },
  },
  setup (props) {
    const { localePath } = useContext()

    const imgStyle = {
      backgroundImage: `url("${props.location.image}")`,
    }
    const getSearchTo = () => {
      return {
        path: localePath(props.location.link),
        query: props.query,
      }
    }

    return {
      imgStyle,
      getSearchTo,
    }
  },
})
